// @flow
import { createTheme } from './utils';
import logotypeImg from './stacksvault/logotype.png';
import transparentLogotypeImg from './stacksvault/transparent_logo.png';
import jumbotronBgImg from './stacksvault/jumbotron_bg.jpg';
import type { Theme } from './types';

export const theme = (parentTheme: Theme) =>
  createTheme(parentTheme, {
    images: {
      logotypeImg,
      logotypeMiniImg: false,
      transparentLogotypeImg,
      jumbotronBgImg,
    },
  });

export default theme;



// WEBPACK FOOTER //
// ./src/themes/stacksvault.js